export default "__VITE_PUBLIC_ASSET__486ed120__"